export default {
  clientOnboardingDetails(state) {
    return state.client;
  },
  creativeOnboardingDetails(state) {
    return state.creative;
  },
};
